import { ErrorDialogComponent } from './error-dialog.component';

export const ERROR_DIALOG_DECLARATIONS = [ErrorDialogComponent];

export * from './error-dialog.component';
